<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-container>
      <v-row justify="center">
        <v-dialog scrollable v-model="loading" persistent max-width="200">
          <v-card>
            <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row justify-center>
                  <v-flex xs12 sm6 md4 lg3>
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
    <material-card
      :title="$t('components.portal.portal_content.configuration')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="mail"
    >
      <v-card-text>
        <v-form
          v-model="valid"
          v-if="payload !== null && payload !== undefined"
        >
          <v-container fluid>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12">
                <vue-json-editor
                  v-model="payload.Json"
                  :expandedOnStart="true"
                  @json-change="onJsonChange"
                ></vue-json-editor>
              </v-col>
            </v-row>
            <v-row>
              <v-col xs="12" sm="6" md="4" lg="3">
                <no-autocomplete-textfield
                  v-model="payload.Domain"
                  :label="$t('components.portal.portal_content.domain')"
                  :rules="[$rules.required]"
                  class="required"
                />
              </v-col>
              <v-col
                xs="12"
                sm="6"
                md="4"
                lg="3"
                v-if="payload.UseLegacyClaims"
              >
                <v-checkbox
                  readonly
                  v-model="payload.UseLegacyClaims"
                  :label="$t('components.portal.portal_content.use_legacy')"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="!valid || livePlan"
          :loading="saving"
          color="primary"
          @click="save"
        >
          {{ $t("globals.save") }}
        </v-btn>
      </v-card-actions>
    </material-card>
    <!-- <file-browser
        :accessToken="token"
        :axiosConfig="{ baseURL: settings.DOCUMENTSERVICEURL + 'api/' }"
        :maxUploadFileSize="5242880"
        :maxUploadFilesCount="5"
        :startingFolderPath="'/' + planOptions.Name + '/'"
        :brokerId="brokerId"
        :planId="selectedPlan.Id"
        :settingsApiUrl="settings.APIURL"
        :maxDataRetrieved="10"
      /> -->
    <material-card :title="$t('views.downloadcenter.files')" icon="description">
      <pbas-data-table
        ref="fileTable"
        :dataProvider="fileProvider"
        :rowActions="fileRowActions"
        :floatActions="fileActions"
        :selectActions="fileSelectActions"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <v-dialog scrollable v-model="dialogs.file" max-width="600" persistent>
      <material-card
        :title="$t('components.portal.portal_content.add_files')"
        icon="description"
        :color="$vuetify.theme.themes.light.secondary"
      >
        <v-card-text v-if="dialogs.file">
          <div class="row">
            <div class="col-md-12 col-xs-12">
              <!-- <multi-file-upload2
                id="addCmsFileId"
                @emit-upload-start="saving = true"
                @emit-upload-end="saving = false"
                :tags="[selectedPlan.UniqueIdentifier + '_portal']"
                :categories="[]"
                :currentFolder="selectedPlan.Name"
                :zipDownloadUrl="
                  settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                "
                :fileUploadUrl="settings.DOCUMENTSERVICEURL + 'api/UploadFiles'"
                @emit-files="
                  files = $event;
                  saving = false;
                "
                @emit-upload-error="
                  error = $event;
                  saving = false;
                "
                :public="true"
              /> -->
              <file-uploader-multi
                ref="uploader"
                :url="uploadUrl"
                v-on:upload-started="onUploadStarted"
                v-on:upload-error="onUploadError"
                v-on:upload-completed="onUploadCompleted($event)"
                :rules="[$rules.required]"
                class="required"
              />
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="uploading"
            @click="
              dialogs.file = false;
              refresh();
            "
            text
          >
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
      <material-card
        :title="
          selectedFile
            ? $t('components.portal.portal_content.delete_file_{0}', [
                trans2(selectedFile, 'Name'),
              ])
            : $t('components.portal.portal_content.delete_many_files')
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="deleteFilesHandler">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <error-handler :error="error" />
    <v-snackbar
      v-model="snackbar"
      color="success"
      :multi-line="false"
      :timeout="timeout"
      :vertical="false"
    >
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { locker } from "@/mixins/locker";
import { planSetter } from "@/mixins/planSetter";
import ErrorHandler from "@/components/ErrorHandler";
import vueJsonEditor from "vue-json-editor";
import { InMemoryProvider } from "pbas-vue-components";
import PortalFilesHeaders from "@/headers/PortalFiles";
import { translate2 } from "@/trans2";
import MultiFileUpload2 from "@/components/MultiFileUpload2.vue";
import { TokenService } from "@/services/token.service";
import FileUploaderMulti from "@/components/FileUploaderMulti";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";

export default {
  components: {
    ErrorHandler,
    vueJsonEditor,
    MultiFileUpload2,
    FileUploaderMulti,
    NoAutocompleteTextfield,
  },
  mixins: [locker, planSetter],
  data() {
    return {
      snackbar: false,
      timeout: 2500,
      saving: false,
      valid: false,
      error: null,
      loading: false,
      uploading: false,
      payload: undefined,
      file: undefined,
      dialogs: {
        delete: false,
        file: false,
      },
      fileProvider: undefined,
      selectedFile: {},
      selectedFiles: [],
      files: [],
      uploadUrl: undefined,
      fileHeaders: PortalFilesHeaders,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("auth", ["role", "user"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
      settings: "settings",
      brokerId: "brokerId",
    }),
    ...mapGetters("plansMembers", ["planIdentity", "planOptions"]),
    token() {
      return TokenService.getToken();
    },
    livePlan() {
      console.log(this.selectedPlan);
      if (this.selectedPlan === null || this.selectedPlan === undefined) return null;
      // return !this.selectedPlan.Current.IsTesting;
      return false;
    },
    fileActions() {
      if (this.livePlan) {
        return [];
      }
      return [
        {
          name: "Add",
          text: "globals.add_new",
          color: this.$vuetify.theme.themes.light.success,
          icon: "add",
          handler: () => {
            this.files = [];
            this.dialogs.file = true;
          },
        },
      ];
    },
    fileSelectActions() {
      if (this.livePlan) {
        return [];
      }
      return [
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: () => {
            this.selectedFile = null;
            this.selectedFiles = this.$refs.fileTable.selected;
            this.dialogs.delete = true;
          },
        },
      ];
    },
    fileRowActions() {
      if (this.livePlan) {
        return [];
      }
      return [
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (e) => {
            this.selectedFile = e;
            this.dialogs.delete = true;
          },
        },
      ];
    },
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("portalsProxy", [
      "getPlanPortalConfiguration",
      "savePlanPortalConfiguration",
    ]),
    ...mapActions("documentsService", [
      "getPortalFiles",
      "deleteFiles",
      "makeFilesPermanent",
    ]),
    trans2(item, field) {
      return translate2(item, field);
    },
    onJsonChange(value) {
      // console.log("value:", value);
    },
    async save() {
      try {
        this.saving = true;
        this.payload.UpdatedBy = this.user;
        this.payload.Source = "JSONupdate";
        await this.savePlanPortalConfiguration({
          planIdentityId: this.selectedPlan.Id,
          payload: this.payload,
        });
        this.snackbar = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    cancel() {
      // this.$router.push({
      //   name: "portal",
      //   params: { planId: this.selectedPlan.Id },
      // });
      this.dialogs.cancel = false;
      this.dialogs.edit = false;
      this.payload = null;
      this.images = [];
    },
    async loadPlanData() {
      try {
        this.loading = true;
        const item = (
          await this.getPlanPortalConfiguration({
            planIdentityId: this.selectedPlan.Id,
          })
        ).data;
        // console.log(item);
        if (item !== null && item !== undefined && item != "") {
          this.payload = item; //JSON.stringify(item, null, 2);
          this.payload.UseLegacyClaims = this.selectedPlan.UseISeriesClaims;
        } else {
          this.payload = {
            json: {},
          };
          this.payload.UseLegacyClaims = this.selectedPlan.UseISeriesClaims;
        }
        // console.log(this.payload);
        // this.uploadUrl =
        //   this.settings.APIURL + "plans/" + this.selectedPlan.Id + "/cms-files";
        this.uploadUrl = `${this.settings.DOCUMENTSERVICEURL}Api/UploadFilesFormData/${this.selectedPlan.UniqueIdentifier}_portal`;
        await this.refresh();
      } catch (error) {
        if (error.response.status === 404) {
          this.payload = {
            json: {},
          };
          this.payload.UseLegacyClaims = this.selectedPlan.UseISeriesClaims;
          this.uploadUrl = `${this.settings.DOCUMENTSERVICEURL}Api/UploadFilesFormData/${this.selectedPlan.UniqueIdentifier}_portal`;
          await this.refresh();
        } else {
          this.error = error;
        }
      } finally {
        this.loading = false;
      }
    },
    async refresh() {
      this.loading = true;
      try {
        let files = (
          await this.getPortalFiles(
            this.selectedPlan.UniqueIdentifier + "_portal"
          )
        ).data;
        if (this.filesProvider === null || this.filesProvider === undefined) {
          this.fileProvider = new InMemoryProvider(
            files.filter((o) => !o.MarkedForDeletion),
            this.fileHeaders
          );
        } else {
          this.fileProvider.items = files.filter((o) => !o.MarkedForDeletion);
        }
        this.$nextTick(() => {
          this.$refs.fileTable.selected = [];
          this.$refs.fileTable.getDataAsync();
        });
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async deleteFilesHandler() {
      let selected = [];
      if (this.selectedFile === null || this.selectedFile === undefined) {
        selected = this.selectedFiles.map((o) => o.Id);
      } else {
        selected = [this.selectedFile.Id];
      }
      if (selected.length > 0) {
        try {
          this.saving = true;
          await this.deleteFiles(selected);
          this.snackbar = true;
          this.dialogs.delete = false;
          await this.refresh();
        } catch (error) {
          this.error = error;
        } finally {
          this.saving = false;
        }
      }
    },
    // async saveFileHandler() {
    //   this.saving = true;
    //   try {
    //     await this.makeFilesPermanent({
    //       payload: {
    //         PlanName: translate2(this.selectedPlan, "Name"),
    //         Files: this.files.map((o) => {
    //           console.log(o);
    //           return { Id: o.file.Id };
    //         }),
    //       },
    //     });
    //     this.snackbar = true;
    //     this.dialogs.file = false;
    //     await this.refresh();
    //   } catch (e) {
    //     console.error(e);
    //   } finally {
    //     this.saving = false;
    //   }
    // },
    onUploadCompleted(res) {
      // console.log(res);
      this.uploading = false;
      this.snackbar = true;
      this.dialogs.file = false;
      this.refresh();
    },
    onUploadStarted() {
      this.uploading = true;
    },
    onUploadError() {
      this.uploading = false;
    },
  },
};
</script>
